import { useSize } from 'ahooks';
export const useHeaderHeight = ()=>{
    const total = useSize(document.querySelector('#page_header'));
    return (total === null || total === void 0 ? void 0 : total.height) || 0;
};
export const useBannerHeight = ()=>{
    const total = useSize(document.querySelector('#banner_wrapper'));
    return (total === null || total === void 0 ? void 0 : total.height) || 0;
};
